import { useEffect, useState } from 'react';

import { fetchOrganizations } from 'api/organizations/organizations';
import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { Organization as OrganizationType } from 'api/organizations/organizations.types';
import { useSelectedOrganization } from 'hooks/useSelectedOrganization/useSelectedOrganization';
import { getObjectInNestedObjectByKey } from 'helpers/getObjectInNestedObjectByKey';

import { Organization } from './Organization';

export const OrganizationContainer = () => {
  const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

  const [organizations, setOrganizations] = useState<OrganizationType[] | null>(null);

  const { data, isLoading: isLoadingOrganization } = useQuery(
    [QueryKeyEnum.ORGANIZATIONS],
    () => fetchOrganizations(),
    {
      args: {
        unfiltered: true,
      },
      onSuccess: (response) => {
        setOrganizations(response || null);

        if (response && selectedOrganization) {
          let updatedSelectedOrganization = null;

          // Search for the selected organization in all root organizations and their children
          for (const rootOrganization of response) {
            const found = getObjectInNestedObjectByKey(rootOrganization, 'id', selectedOrganization.id);

            if (found) {
              updatedSelectedOrganization = found;
              break;
            }
          }

          if (updatedSelectedOrganization) {
            setSelectedOrganization(updatedSelectedOrganization.object);
          }
        }
      },
    },
  );

  useEffect(() => {
    setOrganizations(data || null);
  }, [selectedOrganization]);

  return (
    <Organization
      organizations={organizations}
      setOrganizations={setOrganizations}
      isLoadingOrganization={isLoadingOrganization}
    />
  );
};
